import { Link } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";
import { useLang } from "@/context/LangContext";

/**
 * 404 fallback route. Rendered by the `<Route path="*">` catch-all.
 */
export default function NotFound() {
  const { t } = useLang();
  return (
    <div className="min-h-screen bg-gradient-to-br from-wine-50/40 via-white to-rose-50/30 flex items-center justify-center px-6 py-16">
      <div className="max-w-lg text-center" data-testid="not-found-page">
        <p className="font-mono text-7xl font-black text-wine-600 tracking-tight">404</p>
        <h1 className="mt-4 font-serif text-3xl text-navy">{t("not_found_title")}</h1>
        <p className="mt-3 text-sm text-neutral-600">{t("not_found_message")}</p>
        <div className="mt-8 flex items-center justify-center gap-3">
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center gap-2 rounded-full border border-neutral-200 bg-white px-4 py-2 text-sm font-bold text-neutral-700 hover:bg-neutral-50"
            data-testid="not-found-back"
          >
            <ArrowLeft className="h-4 w-4" /> {t("not_found_back")}
          </button>
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-full bg-wine-600 px-4 py-2 text-sm font-bold text-white hover:bg-wine-700"
            data-testid="not-found-home"
          >
            <Home className="h-4 w-4" /> {t("not_found_home")}
          </Link>
        </div>
      </div>
    </div>
  );
}
